import React from 'react';
import { Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LOGO_WIDE } from '../../utils/brand';
import { appendUtm } from '../../utils/utm';

const SiteFooter = () => {
  return (
    <footer className="border-t border-red-500/20 py-8 px-4" data-testid="site-footer">
      <div className="max-w-6xl mx-auto">
        <div className="text-center space-y-4">
          <div
            className="mb-6 pb-5 border-b border-red-500/10 text-[12.5px] text-gray-400 leading-relaxed space-y-2 text-center"
            data-testid="footer-jurisdiction-notice"
          >
            <p>
              <span className="text-gray-300 font-bold">Outlaw Media</span> is a Melbourne-focused
              crime news outlet headquartered in the United Arab Emirates.
            </p>
            <p>
              <span className="text-gray-400 font-semibold">Registered office:</span>{' '}
              Unit 4101, HDS Business Centre, Cluster M, Al Thanyah Fifth,
              Jumeirah Lakes Towers, Dubai, United Arab Emirates.
            </p>
            <p>
              Any purchases made on this website, along with payments received from our sponsor
              partners, are processed and held in the United Arab Emirates.
            </p>
            <p>
              <span className="text-gray-300 font-bold">Accounts</span> store an email address and a Stripe customer token so
              we can deliver paid access.
            </p>
            <p>
              Payments are processed and held in the United Arab Emirates. We do not sell personal information.
            </p>
          </div>

          <img
            src={LOGO_WIDE}
            alt="Outlaw Media"
            width="1504"
            height="229"
            loading="lazy"
            decoding="async"
            className="h-9 sm:h-10 w-auto max-w-[260px] object-contain mx-auto"
          />
          <p className="text-gray-500 text-xs">
            © 2024-2026 Outlaw Media. Independent Melbourne Crime Journalism.
          </p>
          <p className="text-gray-600 text-xs">
            Founded by Ryan Naumenko | Born in Melbourne | Based in Dubai
          </p>

          <div className="flex items-center justify-center gap-6 pt-4">
            <a
              href="https://instagram.com/ryannaumenko"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-400 transition-colors"
              title="Instagram"
              data-testid="footer-instagram-link"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              href="https://x.com/ryan_naumenko"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-400 transition-colors text-xs font-black"
              title="X (Twitter)"
              data-testid="footer-x-link"
            >
              X
            </a>
            <a
              href="https://youtube.com/@ryan.naumenko"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-400 transition-colors text-xs font-semibold"
              title="YouTube"
              data-testid="footer-youtube-link"
            >
              YouTube
            </a>
          </div>

          <div className="flex justify-center gap-4 text-xs pt-2 flex-wrap">
            <Link to={appendUtm("/login")} className="text-red-400 hover:text-white transition-colors font-bold" data-testid="footer-signup-link">Sign up · Subscribe</Link>
            <Link to="/stories" className="text-gray-500 hover:text-red-400 transition-colors" data-testid="footer-stories-link">Read Our Investigations</Link>
            <Link to={appendUtm("/subscribe")} className="text-gray-500 hover:text-red-400 transition-colors" data-testid="footer-subscribe-link">Supporter tiers</Link>
            <Link to="/founders" className="text-gray-500 hover:text-red-400 transition-colors" data-testid="footer-founders-link">Founders</Link>
            <Link to="/privacy" className="text-gray-500 hover:text-red-400 transition-colors" data-testid="footer-privacy-link">Privacy</Link>
            <Link to="/terms" className="text-gray-500 hover:text-red-400 transition-colors" data-testid="footer-terms-link">Terms</Link>
            <a href="mailto:ryan@outlawmedia.com.au" className="text-gray-500 hover:text-red-400 transition-colors" data-testid="footer-contact-link">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
